/* VueRounter的写法 */
// import router from '@/router'
// router.beforeEach(async (to, from) => {
//  /* 暂时没有做好首页，直接重定向到某个软件的落地页 */
//  if(to.name === 'home')
  //  return { name: 'soft-batchrename' }
// })


/* Nuxt的路由中间件写法 */
export default defineNuxtRouteMiddleware((to, from) => {
  if(to.name === 'home')
    return navigateTo({ name: 'soft-batchrename' })
})
